import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "UniformAuthService",
  controller: "Tree",
};
const methods = [
  "GetAreaAndOrgTreeByUserId",
  "GetOrgTreeByUserId",
  "GetRoleTree",
  "GetMenuTree",
  "UpdateTreeOrderIndex",
  "GetAreaTree",
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function(data) {
      return this.post(path, data);
    };
  });
};
const TreeApi = ZJApi.defineNewApi("TreeApi", factory);

export default TreeApi;
